import {Component, createContext} from '~preact';
import PropTypes from "prop-types";

export let ThemeComponentsContext = createContext();
class ThemeComponentsProvider extends Component {
	render({components, children}, {}) {
		return (
			<ThemeComponentsContext.Provider value={components}>
				{children}
			</ThemeComponentsContext.Provider>
		);
	}

	static get propTypes() {
		return {
			children: PropTypes.any,

			/**
			 * @type Object<string, function>
			 */
			components: PropTypes.object,
		}
	}
}

export default ThemeComponentsProvider;
